export default __webpack_public_path__ + "static/media/style5.f7329fc3.svg";